<template>
	<div>
		<h6 class="ml-2"><strong>Agency Details</strong></h6>
		<form @submit.prevent="postIntegrationSettings" class="mb-3">
			<div class="row p-3">

				<div class="col">
					<div class="form-group">
						<label>Shift Blocking</label>
						<div class="mt-2 radio-button">
							<input type="radio" class="" id="one" value="1" v-model="editable_org_integration.shift_blocking">
							<label for="one">Yes</label>
							<input type="radio"  class=" ml-2" id="two" value="0" v-model="editable_org_integration.shift_blocking">
							<label for="two" >No</label>
						</div>
					</div>
					<div class="form-group input-content">
						<label>Discipline</label>
						<div class="input-content input-content-horizontal">
							<v-select :searchable="false" name="integration_options" multiple  v-model="editable_org_integration.discipline" :options="discipline" label="name" class="status_import v-select-no-height"></v-select>
						</div>
					</div>
					<div class="form-group input-content">
						<label>Status to Import</label>
						<div class="input-content input-content-horizontal">
							<v-select :searchable="false" name="integration_options" multiple  v-model="editable_org_integration.status_import" :options="status_to_import" label="name" class="status_import v-select-no-height"></v-select>
						</div>
					</div>
					<div class="form-group">
						<label>Import Applicants</label>
						<div class="mt-2 radio-button">
							<input type="radio" class="" id="one" value="1" v-model="editable_org_integration.import_applicants">
							<label for="one">Yes</label>
							<input type="radio"  class=" ml-2" id="two" value="0" v-model="editable_org_integration.import_applicants">
							<label for="two" >No</label>
						</div>
					</div>
					<div class="form-group input-content ">
						<label>PayCodes</label>
						<div class="input-content">
							<textarea v-model="editable_org_integration.paycodes"></textarea>
						</div>
					</div>
				</div>

				<div class="col">
					<div class="form-group">
						<label>Realtime Report</label>
						<div class="mt-2 radio-button">
							<input type="radio" class="" id="one" value="1" v-model="editable_org_integration.realtime_report">
							<label for="one">Yes</label>
							<input type="radio"  class="ml-2" id="two" value="0" v-model="editable_org_integration.realtime_report">
							<label for="two" >No</label>
						</div>							
					</div>
					<div class="form-group input-content">
						<label>Phone Field</label>
						<v-select name="integration_options" v-model="editable_org_integration.phone_field" :options="phone_field" label="name"></v-select>	
					</div>
					<div class="form-group input-content">
						<label>Location</label>
						<v-select name="integration_options" v-model="editable_org_integration.location" :options="location" label="name"></v-select>	
					</div>
					<div class="form-group input-content">
						<label>Sublocation</label>
						<v-select name="integration_options" v-model="editable_org_integration.sublocation" :options="sublocation" label="name"></v-select>	
					</div>
					<div class="form-group input-content ">
						<label>Notes</label>
						<div class="input-content">
							<textarea v-model="editable_org_integration.notes"></textarea>
						</div>
					</div>		
				</div>

				<div class="col">

					<div class="form-group input-content">
						<label>Date Selection</label>
						<div>
							<p>
							Select the order of what Date value you would prefer as the Employees' "Employment Date". 
							If the sequence given does not produce any date value - HireDate will be used by deault.
							</p>
						</div>
						<div class="input-content input-content-horizontal">
							<v-select :searchable="false" name="integration_options" multiple  v-model="editable_org_integration.date_selection" :options="date_selection" label="name" class="status_import v-select-no-height"></v-select>
						</div>
					</div>

					<label>Active Integration</label>
					<div class="mt-2">
						<date-picker placeholder="Active integration date" class="date_picker_new" v-model="editable_org_integration.active_int_date" 
							:range="false" 
							:format="'MM-DD-YYYY'"
							:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
							:valueType="'YYYY-MM-DD'">
						</date-picker>
					</div>
				</div>
			</div>

			<h6 class="ml-2"><strong>Report Settings</strong></h6>


					<div class="row ml-4 mt-4">
						<div class="form-group">
							<input type="checkbox" id="daily" value="daily" v-model="selected_frequencies">
							<label for="daily"> Daily </label><br>
						</div>

						<div class="col-3">

						<div v-show="selected_frequencies.includes('daily')" class="form-group input-content ml-4">
							<label>Email Address for Daily Reports</label>
							<div class="input-content">
								<input v-model="editable_org_integration.nightly_report_emails" type="text"/>
								<p class="font-size-10">Seperate multiple addresses with comma ','</p>
							</div>
						</div>
						</div>
					</div>

					<div class="row ml-4 ">
						<div class="form-group">
							<input type="checkbox" id="weekly" value="weekly" v-model="selected_frequencies">
							<label for="weekly"> Weekly </label><br>						
						</div>

						<div class="col-3">

						<div v-show="selected_frequencies.includes('weekly')" class="form-group input-content mx-2">
							<label>Email Address for Weekly Reports</label>
							<div class="input-content">
								<input v-model="editable_org_integration.weekly_report_emails" type="text"/>
								<p class="font-size-10">Seperate multiple addresses with comma ','</p>
							</div>
						</div>
						</div>
						<div class="col-3">

						<div v-show="selected_frequencies.includes('weekly')" class="form-group input-content">
							<label>Day of the Week for Weekly Reports</label>
							<v-select name="integration_options" v-model="editable_org_integration.report_frequency_day" :options="report_frequency_day" label="name"></v-select>	
						</div>
						</div>
					</div>


			<h6 class="ml-2"><strong>API Details</strong></h6>

			<div class="row p-3">
				<div class="col">
					<div class="form-group input-content ">
						<label>Base URL</label>
						<div class="input-content">
							<input  :class="{ 'not-allowed' : org_integration.base_url != '' }" :disabled="org_integration.base_url != ''"  v-model="editable_org_integration.base_url" type="text"/>
						</div>
					</div>
					<div class="form-group input-content ">
						<label>HHAX Agency ID</label>
						<div class="input-content">
							<input  :class="{ 'not-allowed' : org_integration.hhax_agency_id != '' }" :disabled="org_integration.hhax_agency_id != ''" v-model="editable_org_integration.hhax_agency_id" type="text"/>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="form-group input-content ">
						<label>App Name</label>
						<div class="input-content">
							<input  :class="{ 'not-allowed' : org_integration.app_name != '' }" :disabled="org_integration.app_name != ''"   v-model="editable_org_integration.app_name" type="text"/>
						</div>
					</div>
					<div class="form-group input-content ">
						<label>App Secret</label>
						<div class="input-content">
							<input :class="{ 'not-allowed': org_integration.app_secret_secure}" :disabled="org_integration.app_secret_secure != ''"  v-model="editable_org_integration.app_secret_secure" type="text"/>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="form-group input-content ">
						<label>App Key</label>
						<div class="input-content">
							<input :class="{ 'not-allowed' : org_integration.app_key_secure != '' }"  
							:disabled="org_integration.app_key_secure != ''"  v-model="editable_org_integration.app_key_secure" type="text"/>
						</div>
					</div>
				</div>
			</div>
			<button type="submit" class="button large-button integration-button">Save Integration</button>
		</form>
	</div>
</template>
<script>
export default {	
	props:{
		integration_id: Number
	},
	data : function(){
		return{
			name: '',
			picked: 'No',
			import_applicants:0,
			realtime_report:1,
			selected_frequencies: ["daily"],
			discipline: [
				{id: 0, name: 'ADM'},
				{id: 1, name: 'APC'},
				{id: 2, name: 'CBSA'},
				{id: 3, name: 'CH'},
				{id: 4, name: 'CNA'},
				{id: 5, name: 'COMP'},
				{id: 6, name: 'ESC'},
				{id: 7, name: 'HCSS'},
				{id: 8, name: 'HHA'},
				{id: 9, name: 'HHA -C'},
				{id: 10, name: 'HM'},
				{id: 11, name: 'HMK'},
				{id: 12, name: 'HSK'},
				{id: 13, name: 'ILST'},
				{id: 14, name: 'LPN'},
				{id: 15, name: 'MSW'},
				{id: 16, name: 'NINS'},
				{id: 17, name: 'NT'},
				{id: 18, name: 'OT'},
				{id: 19, name: 'PA'},
				{id: 20, name: 'PBIS'},
				{id: 21, name: 'PC'},
				{id: 22, name: 'PCA'},
				{id: 23, name: 'PT'},
				{id: 24, name: 'RESP'},
				{id: 25, name: 'RN'},
				{id: 26, name: 'RT'},
				{id: 27, name: 'SCI'},
				{id: 28, name: 'SCM'},
				{id: 29, name: 'SDP'},
				{id: 30, name: 'SHC'},
				{id: 31, name: 'SHHA'},
				{id: 32, name: 'SPC'},
				{id: 33, name: 'ST'},
				{id: 34, name: 'Other (Skilled)'},
				{id: 35, name: 'Other (Non Skilled)'},
			],
			status_to_import: [
				{id: 0, name: 'Active'},
				{id: 1, name: 'Hold'},
				{id: 2, name: 'On Leave'},
				{id: '3', name: 'Rejected'},
				{id: '4', name: 'Terminated'},
				{id: '5', name: 'Inacitve'},
			],
			phone_field: [
				{id: 0, name: 'Phone 2'},
				{id: 1, name: 'Phone 3'},
				{id: 2, name: 'Mobile SMS'},
				{id: 3, name: 'Home Phone'}
			],
			location: [
				{id: 0, name: 'Default'},
				{id: 1, name: 'Office'},
				{id: 2, name: 'Branch'},
			],
			sublocation: [
				{id: 0, name: 'Default'},
				{id: 1, name: 'Office'},
				{id: 2, name: 'Branch'},
			],
			report_frequency_day: [
				{id: 1, name: 'Monday'},
				{id: 2, name: 'Tuesday'},
				{id: 3, name: 'Wednesday'},
				{id: 4, name: 'Thursday'},
				{id: 5, name: 'Friday'},
				{id: 6, name: 'Saturday'},
				{id: 7, name: 'Sunday'},
			],
			date_selection: [
				{id: 1, name: 'HireDate'},
				{id: 2, name: 'FirstWorkDate'},
				{id: 3, name: 'RehireDate'},
				{id: 4, name: 'ApplicationDate'},
				{id: 5, name: 'RegistryDate'},
				{id: 6, name: 'SignedPayrollAgreementDate'},
			],
			org_integration:{
				realtime_report: '',
				import_applicants: '',
				shift_blocking: '',
				status_import: '',
				phone_field: '',
				active_int_date: '',
				nightly_report_emails: '',
				weekly_report_emails: '',
				paycodes: '',
				base_url: '',
				hhax_agency_id: '',
				app_name: '',
				app_secret_secure:'',
				app_key_secure:'',
				discipline: '',
				location: '',
				sublocation: '',
				notes: '',
				report_frequency: '',
				report_frequency_day: '',
				date_selection: '',
			},
			editable_org_integration:{
				realtime_report: '',
				import_applicants: '',
				shift_blocking: '',
				status_import: '',
				phone_field: '',
				active_int_date: '',
				nightly_report_emails: '',
				weekly_report_emails: '',
				paycodes: '',
				base_url: '',
				hhax_agency_id: '',
				app_name: '',
				app_secret_secure:'',
				app_key_secure:'',
				discipline: '',
				location: '',
				sublocation: '',
				notes: '',
				report_frequency: '',
				report_frequency_day: '',
				date_selection: '',
			},
			temp_org_integration: {}
			
		}
	},
	created : function(){
		// this.org_integration.id = this.$route.params.id
		// this.org_integration.integration_id = this.integration_id
		this.getIntegrationSettings()

	},
	methods : {
		getIntegrationSettings(){ 
			var params = {
				id: this.$route.params.agency_id,
				integration_id: this.integration_id,
			}
			this.$store.dispatch('getOrganizationIntegrationSettings', params).then((res) => {
				if(res.data.length == 0){
				}else{
					this.assignKeyValues(res.data, this.editable_org_integration)
					this.assignKeyValues(res.data, this.org_integration)
					if(res.data.status_import){
						this.getStatusImportValues(res.data)
						this.editable_org_integration.status_import = this.org_integration.status_import 
					}
					if(res.data.discipline){
						this.getDiciplineValues(res.data)
						this.editable_org_integration.discipline = this.org_integration.discipline
					}
					if(res.data.date_selection){
						this.getSelectedDateValues(res.data)
						this.editable_org_integration.date_selection = this.org_integration.date_selection
					}
					if(res.data.phone_field){
						this.getPhoneFieldValue(res.data)
						this.editable_org_integration.phone_field = this.org_integration.phone_field 
					}
					if(res.data.location || res.data.sublocation){
						this.getLocationSublocationValues(res.data)
						this.editable_org_integration.location = this.org_integration.location
						this.editable_org_integration.sublocation = this.org_integration.sublocation
					}
					if(res.data.report_frequency_day){
						this.getReportFrequencyValues(res.data)
						this.editable_org_integration.report_frequency_day = this.org_integration.report_frequency_day
					}
					if (res.data.report_frequency) {
						if (res.data.report_frequency == 0) {
							this.selected_frequencies = [];
						} else if (res.data.report_frequency == 1) {
							this.selected_frequencies = ['daily'];
						} else if (res.data.report_frequency == 2) {
							this.selected_frequencies = ['weekly'];
						} else if (res.data.report_frequency == 3) {
							this.selected_frequencies = ['daily', 'weekly'];
						}
						console.log(this.selected_frequencies);
					}
				}
				
			
			}).catch((error) => {
					console.log(error);
			});
		},
		postIntegrationSettings(){ 
			this.temp_org_integration = this.removeEmptyKeyValues(this.editable_org_integration)
			if(this.temp_org_integration.status_import){
				this.temp_org_integration.status_import = this.temp_org_integration.status_import.map(elem =>{ return elem.id })
			}
			if(this.temp_org_integration.phone_field){
				this.temp_org_integration.phone_field = this.temp_org_integration.phone_field.id
			}
			if(this.temp_org_integration.location){
				this.temp_org_integration.location = this.temp_org_integration.location.id
			}
			if(this.temp_org_integration.sublocation){
				this.temp_org_integration.sublocation = this.temp_org_integration.sublocation.id
			}
			if(this.temp_org_integration.discipline){
				this.temp_org_integration.discipline = this.temp_org_integration.discipline.map(elem =>{ return elem.id })
			}
			if(this.temp_org_integration.date_selection){
				this.temp_org_integration.date_selection = this.temp_org_integration.date_selection.map(elem =>{ return elem.id })
			}
			if(this.temp_org_integration.report_frequency_day){
				this.temp_org_integration.report_frequency_day = this.temp_org_integration.report_frequency_day.id
			}
			if (this.selected_frequencies.length !== 0) {
				if (this.selected_frequencies.length > 1) {
					this.temp_org_integration.report_frequency = 3;
				} else {
					if (this.selected_frequencies.includes('daily')) {
						this.temp_org_integration.report_frequency = 1;
					}
					if (this.selected_frequencies.includes('weekly')) {
						this.temp_org_integration.report_frequency = 2;
					}
				}
			} else {
				this.temp_org_integration.report_frequency = 0;
			}
			var params = {
				id: this.$route.params.agency_id,
				integration_id: this.integration_id,
				filters: this.temp_org_integration
			}

			this.$store.dispatch('UpdateOrganizationIntegrationSettings', params).then((res) => {
				this.temp_org_integration = {}
				this.getIntegrationSettings()
			
			}).catch((error) => {
					console.log(error);
			});
		},
		getStatusImportValues(res){
			if(typeof this.org_integration.status_to_import != Array){
				this.org_integration.status_import = [...this.org_integration.status_import]
			}
			this.status_to_import.forEach(elem => {
				if(res.status_import.includes(elem.id.toString())){
					this.org_integration.status_import.push(elem)
				}
			})
			this.org_integration.status_import = this.org_integration.status_import.filter(elem => {if(typeof elem === 'object'){
				return elem
			}})
		},
		getDiciplineValues(res){
			if(typeof this.org_integration.discipline != Array){
				this.org_integration.discipline = [...this.org_integration.discipline]
			}
			this.discipline.forEach(elem => {
				if(res.discipline.includes(elem.id.toString())){
					this.org_integration.discipline.push(elem)
				}
			})
			this.org_integration.discipline = this.org_integration.discipline.filter(elem => {if(typeof elem === 'object'){
				return elem
			}})
		},
		getSelectedDateValues(res){
			if(typeof this.org_integration.date_selection != Array){
				this.org_integration.date_selection = [...this.org_integration.date_selection]
			}

			console.log(this.org_integration.date_selection);

			res.date_selection.forEach(id => {				
				const found = this.date_selection.find(element => element.id == parseInt(id));
				this.org_integration.date_selection.push(found);

			})

			this.org_integration.date_selection = this.org_integration.date_selection.filter(elem => {if(typeof elem === 'object'){
				return elem
			}})
		},
		getPhoneFieldValue(res){
			this.phone_field.forEach(elem => {
				if(res.phone_field == (elem.id.toString())){
					this.org_integration.phone_field = elem
				}
			})
		},
		getLocationSublocationValues(res){
			this.location.forEach(elem => {
				if(res.location == (elem.id.toString())){
					this.org_integration.location = elem
				}
			})

			this.sublocation.forEach(elem => {
				if(res.sublocation == (elem.id.toString())){
					this.org_integration.sublocation = elem
				}
			})
		},
		getReportFrequencyValues(res){
			this.report_frequency_day.forEach(elem => {
				if(res.report_frequency_day == (elem.id.toString())){
					this.org_integration.report_frequency_day = elem
				}
			})
		},
		removeEmptyKeyValues: function(obj){
			var new_obj = {}
			  for (var propName in obj) {
				if ( obj[propName] != '') {
					new_obj[propName] = obj[propName]
				}
			}
			return new_obj
		},
		assignKeyValues: function(obj, obj_to_assign){
			for (var propName in obj) {
				if ( obj[propName] != '') {
					obj_to_assign[propName] = obj[propName]
				}
			}
		}

	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/integration/HHAXIntegration.vue